import { useEffect } from "react";
import { useNavigate } from "react-router";
import UserManager from "../components/user-management";
import { getUserInfo } from "../utils/utils";
import { userRoles } from "../config";

const UserManagement = () => {
  const navigate = useNavigate();
  const { role } = getUserInfo();

  useEffect(() => {
    if (role !== userRoles?.admin) {
      navigate("/dashboard-view");
    }
  }, [role, navigate]);

  return <UserManager />;
};

export default UserManagement;
